/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} A11y_Statement_Limitations_Ai_PanelsInputs */

const en_a11y_statement_limitations_ai_panels = /** @type {(inputs: A11y_Statement_Limitations_Ai_PanelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Some complex interactive elements (e.g., AI progress panels) may have limited screen reader support`)
};

const de_a11y_statement_limitations_ai_panels = /** @type {(inputs: A11y_Statement_Limitations_Ai_PanelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einige komplexe interaktive Elemente (z.B. KI-Fortschrittspanels) haben möglicherweise eingeschränkte Screenreader-Unterstützung`)
};

const fr_a11y_statement_limitations_ai_panels = /** @type {(inputs: A11y_Statement_Limitations_Ai_PanelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Certains elements interactifs complexes (p. ex. panneaux de progression IA) peuvent avoir un support limite pour les lecteurs d'ecran`)
};

const es_a11y_statement_limitations_ai_panels = /** @type {(inputs: A11y_Statement_Limitations_Ai_PanelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algunos elementos interactivos complejos (p. ej., paneles de progreso de IA) pueden tener soporte limitado para lectores de pantalla`)
};

const it_a11y_statement_limitations_ai_panels = /** @type {(inputs: A11y_Statement_Limitations_Ai_PanelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alcuni elementi interattivi complessi (ad es. pannelli di progresso IA) possono avere supporto limitato per screen reader`)
};

const nl_a11y_statement_limitations_ai_panels = /** @type {(inputs: A11y_Statement_Limitations_Ai_PanelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sommige complexe interactieve elementen (bijv. AI-voortgangspanelen) hebben mogelijk beperkte schermlezerondersteuning`)
};

const pl_a11y_statement_limitations_ai_panels = /** @type {(inputs: A11y_Statement_Limitations_Ai_PanelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niektore zlozone elementy interaktywne (np. panele postepu AI) moga miec ograniczona obsluge czytnikow ekranu`)
};

const fi_a11y_statement_limitations_ai_panels = /** @type {(inputs: A11y_Statement_Limitations_Ai_PanelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Joillakin monimutkaisilla interaktiivisilla elementeillä (esim. AI-edistymispaneelit) voi olla rajallinen ruudunlukijatuki`)
};

const da_a11y_statement_limitations_ai_panels = /** @type {(inputs: A11y_Statement_Limitations_Ai_PanelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nogle komplekse interaktive elementer (f.eks. AI-fremskridtspaneler) har muligvis begrsenset skaermlaeserstotte`)
};

const sv_a11y_statement_limitations_ai_panels = /** @type {(inputs: A11y_Statement_Limitations_Ai_PanelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vissa komplexa interaktiva element (t.ex. AI-framstegspaneler) kan ha begransat skarmlasarstod`)
};

/**
* | output |
* | --- |
* | "Some complex interactive elements (e.g., AI progress panels) may have limited screen reader support" |
*
* @param {A11y_Statement_Limitations_Ai_PanelsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const a11y_statement_limitations_ai_panels = /** @type {((inputs?: A11y_Statement_Limitations_Ai_PanelsInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<A11y_Statement_Limitations_Ai_PanelsInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_a11y_statement_limitations_ai_panels(inputs)
	if (locale === "fr") return fr_a11y_statement_limitations_ai_panels(inputs)
	if (locale === "es") return es_a11y_statement_limitations_ai_panels(inputs)
	if (locale === "it") return it_a11y_statement_limitations_ai_panels(inputs)
	if (locale === "nl") return nl_a11y_statement_limitations_ai_panels(inputs)
	if (locale === "pl") return pl_a11y_statement_limitations_ai_panels(inputs)
	if (locale === "fi") return fi_a11y_statement_limitations_ai_panels(inputs)
	if (locale === "da") return da_a11y_statement_limitations_ai_panels(inputs)
	if (locale === "sv") return sv_a11y_statement_limitations_ai_panels(inputs)
	return en_a11y_statement_limitations_ai_panels(inputs)
});